import { render } from "./loandashboard.vue?vue&type=template&id=b879ba36&scoped=true"
import script from "./loandashboard.vue?vue&type=script&lang=js"
export * from "./loandashboard.vue?vue&type=script&lang=js"

import "./loandashboard.vue?vue&type=style&index=0&id=b879ba36&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b879ba36"]])

export default __exports__